import { Trans, useTranslation } from "react-i18next";
import { URL_CONTACT_US } from "~/utils/url/staticUrls";
import { type ResultsHeaterProps } from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage";
import { Link } from "~/common/components/Link";
import { resolveUrl } from "~/utils/url/urlResolver";
import { Button } from "~/common/mui";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { usePurchasePlace, usePurchaseType } from "~/app/analytics/ga/recommendations/RecommendationContexts";
import { appendPurchaseParams } from "~/features/productDetails/components/ProductSummary/PdpSummaryHelper";
import {
  ResultTitle,
  ResultList,
  ResultListItem,
  ResultListItemBanner,
  ResultListItemRow,
  ResultListItemImage,
  ResultListItemContent,
  ResultListItemName,
  ResultListItemDescription,
  ResultListItemLink,
  EmptyStateSection,
  EmptyStateTitle,
  EmptyStateImage,
  EmptyStateDescription,
  EmptyStateList,
} from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage.styles";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

interface TableProps {
  data: ResultsHeaterProps[];
}

export function ResultHS({ data }: TableProps) {
  const { t } = useTranslation();
  const isMinTablet = useIsMinTabletSize();

  const purchase_place = usePurchasePlace();
  const purchase_type = usePurchaseType();

  const linkElement = (item: ResultsHeaterProps) => {
    const href = appendPurchaseParams(item.url, purchase_place, purchase_type);
    return (
      <Link href={href} iconBefore={<KeyboardArrowRightIcon  />}>
        {t("heaterSelectionAssistant.result.item.link", { name: item.name })}
      </Link>
    );
  };

  if (data.length > 0) {
    return (
      <>
        <ResultTitle>{t("heaterSelectionAssistant.results.title")}</ResultTitle>
        <ResultList>
          {data.map((item, index) => (
            <ResultListItem key={index}>
              {index === 0 && (
                <ResultListItemBanner>
                  {t("heaterSelectionAssistant.result.item.optimal.label")}
                </ResultListItemBanner>
              )}
              <ResultListItemRow>
                <ResultListItemImage src={item.imageUrl} />
                <ResultListItemContent>
                  <ResultListItemName>{item.name}</ResultListItemName>
                  <ResultListItemDescription>
                    <Trans i18nKey={"heaterSelectionAssistant.result.item.description"}>
                      SMART/BASIC HEATER suitable for bearings up to <span>{{ mass: item.mass }}</span> kg
                    </Trans>
                  </ResultListItemDescription>
                  {isMinTablet && (
                    <ResultListItemLink>
                      {linkElement(item)}
                    </ResultListItemLink>
                  )}
                </ResultListItemContent>
              </ResultListItemRow>
              {!isMinTablet && (
                <ResultListItemLink>
                  {linkElement(item)}
                </ResultListItemLink>
              )}
            </ResultListItem>
          ))}
        </ResultList>
      </>
    );
  } else {
    return (
      <EmptyStateSection>
        <EmptyStateTitle>{t("heaterSelectionAssistant.emptyState.title")}</EmptyStateTitle>
        <EmptyStateImage
          src={"https://cdn.schaeffler-ecommerce.com/cdn/illustrationEmptyHeaterSelectionAssistant.png"}
        />
        <EmptyStateDescription>{t("heaterSelectionAssistant.emptyState.description")}</EmptyStateDescription>
        <EmptyStateList>
          <li>{t("heaterSelectionAssistant.emptyState.stepOne")}</li>
          <li>
            <Trans i18nKey={"heaterSelectionAssistant.emptyState.stepTwo"}>
              {""}
              <a href={resolveUrl("/mount/induction-units-with-medium-frequency-technology")} target="_blank">
                Explore
              </a>{" "}
              alternative ways of mounting and dismounting bearings.
            </Trans>
          </li>
        </EmptyStateList>
        <Button href={URL_CONTACT_US}>
          {t("heaterSelectionAssistant.emptyState.button")}
        </Button>
      </EmptyStateSection>
    );
  }
}
